module.exports = __webpack_public_path__ + "img/fees.daily.bbbd6061.png";